import React, { useState, useRef } from 'react';
import axios from 'axios';
import './App.css';

const API_URL = 'http://localhost:5001';

function App() {
  const [originalImage, setOriginalImage] = useState(null);
  const [processedImage, setProcessedImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    handleSelectedFile(file);
  };

  const handleSelectedFile = (file) => {
    if (!file) return;

    // Check file type
    const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/jpg'];
    if (!validTypes.includes(file.type)) {
      setError('Please select a valid image file (JPEG, PNG, or GIF)');
      return;
    }

    // Check file size (max 10MB)
    if (file.size > 10 * 1024 * 1024) {
      setError('File size should be less than 10MB');
      return;
    }

    setError('');
    setOriginalImage(URL.createObjectURL(file));
    setProcessedImage(null);
    uploadFile(file);
  };

  const uploadFile = async (file) => {
    setIsLoading(true);
    setError('');
    const formData = new FormData();
    formData.append('image', file);
  
    try {
      console.log('Tentando método Python de alta qualidade...');
      // Primeiro tentar o método Python
      const response = await axios.post(`${API_URL}/upload-python`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout: 30000 // Processamento pode levar mais tempo
      });
  
      if (response.data && response.data.imageUrl) {
        setProcessedImage(`${API_URL}${response.data.imageUrl}`);
        console.log('Método Python funcionou!');
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (err) {
      console.error('Erro no método Python:', err);
      // Continuar com os outros métodos existentes...
      
      // Se o método Python falhar, tente o método padrão
      try {
        // ... (resto do código existente para tentar os outros métodos)
      } catch (mainErr) {
        // ... (código existente)
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    
    if (event.dataTransfer.files && event.dataTransfer.files[0]) {
      handleSelectedFile(event.dataTransfer.files[0]);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const downloadImage = () => {
    const link = document.createElement('a');
    link.href = processedImage;
    link.download = 'processed-image.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="container">
      <header className="header">
        <h1 className="text-4xl font-bold text-blue-600">HideBG</h1>
        <p className="text-lg text-gray-600 mt-2">Remove image backgrounds with one click</p>
      </header>

      <main className="main-content">
        {!processedImage ? (
          <div 
            className={`upload-area ${isDragging ? 'dragging' : ''}`}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
          >
            <h2 className="text-xl font-semibold mb-4">Upload an Image</h2>
            <p className="text-gray-500 mb-4">Drag and drop an image here, or click to select</p>
            
            <button 
              onClick={handleButtonClick} 
              className="btn btn-primary"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="loading-spinner"></span>
                  Processing...
                </>
              ) : 'Select Image'}
            </button>
            
            <input 
              type="file" 
              ref={fileInputRef}
              onChange={handleFileChange} 
              accept="image/png, image/jpeg, image/gif"
              className="hidden"
            />
            
            {error && <p className="error-message">{error}</p>}
            
            {originalImage && !processedImage && (
              <div className="image-preview mt-4">
                <h3 className="text-md font-medium mb-2">Preview:</h3>
                <img src={originalImage} alt="Preview" />
              </div>
            )}
          </div>
        ) : (
          <div className="result-container">
            <div className="original-vs-result">
              <div className="image-card">
                <h3>Original</h3>
                <img src={originalImage} alt="Original" />
              </div>
              
              <div className="image-card">
                <h3>Background Removed</h3>
                <div className="checkerboard-bg">
                  <img src={processedImage} alt="Processed" />
                </div>
              </div>
            </div>
            
            <div className="flex gap-4 mt-4">
              <button onClick={downloadImage} className="btn btn-primary">
                Download PNG
              </button>
              
              <button 
                onClick={() => {
                  setOriginalImage(null);
                  setProcessedImage(null);
                  setError('');
                }} 
                className="btn btn-secondary"
              >
                Process Another Image
              </button>
            </div>
            
            {error && <p className="error-message mt-4">{error}</p>}
          </div>
        )}
      </main>
      
      <footer className="text-center text-gray-500 mt-8 text-sm">
        &copy; {new Date().getFullYear()} HideBG - Background Removal Tool
      </footer>
    </div>
  );
}

export default App; 